import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../shared/modals/modal.component';

import {
  hideChartAccountModalForDelete,
  deleteChartAccount,
} from './store/actions';
import { isRemovingChartAccountInProgressSelector } from './store/selectors';
import { requiredWhenPresent } from '../../shared/propTypes';

class DeleteChartAccountModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    removeEntity: PropTypes.func.isRequired,
    entityToRemove: requiredWhenPresent(['isVisible'], PropTypes.shape({
      localAccount: PropTypes.string.isRequired,
      localAccountDescription: PropTypes.string.isRequired,
      rowIndex: PropTypes.number.isRequired,
    })),
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    chartName: requiredWhenPresent(['isVisible'], PropTypes.shape({
      value: PropTypes.string.isRequired,
    })),
    isDeletingInProgress: PropTypes.bool,
    isVisible: PropTypes.bool,
  };

  removeChartAccount = () => {
    const {
      removeEntity,
      period,
      entityToRemove,
      chartName,
    } = this.props;

    removeEntity({
      period,
      chartName,
      localAccount: entityToRemove.localAccount,
      rowIndex: entityToRemove.rowIndex,
    });
  };

  render() {
    const {
      hideModal,
      period,
      chartName,
      entityToRemove,
      isVisible,
      isDeletingInProgress,
    } = this.props;

    return (
      <Modal
        className="delete-chart-account-modal"
        dismissText="Cancel"
        submitText="Yes"
        title="Delete Chart Account"
        closeAction={hideModal}
        dismissAction={hideModal}
        submitAction={this.removeChartAccount}
        isVisible={isVisible}
        isSubmitting={isDeletingInProgress}
      >
        {
          entityToRemove
            ? (
              <div>
                Are you sure you want to delete: <br/><br/>
                Chart Name: {chartName.value}<br/>
                Local Account: {entityToRemove.localAccount}<br/>
                Local Account Description: {entityToRemove.localAccountDescription}<br/>
                Period: {period.name}<br/><br/>
              </div>
            )
            : null
        }
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isDeletingInProgress: isRemovingChartAccountInProgressSelector(state),
});

export default connect(
  mapStateToProps,
  {
    hideModal: hideChartAccountModalForDelete,
    removeEntity: deleteChartAccount,
  }
)(DeleteChartAccountModal);
